import React from 'react';
import { Description, Image, Link, renderLineBreak, SubTitle } from '../../components/layouts';
import { buildImageURL } from '../../helpers';
import './style.scss';

const IMAGES = {
  d: {
    i1: buildImageURL('/night-before-s.png'),
    i2: buildImageURL('/night-after-s.png')
  },
  m: {
    i1: buildImageURL('/night-before-s.png'),
    i2: buildImageURL('/night-after-s.png')
  }
};

export function NightFadeStatic({ mobile = false }) {
  return (
    <div className="page-section section-night-fade-static inverted">
      <div className="section-content center">
        <SubTitle>
          黑光夜视 2.0
          <br />
          追光，再晚也不迟
        </SubTitle>
        <Description>
          得益于 f/1.6 超大光圈主摄，同时采用全新 AI 降噪模型进行高精度噪声处理，黑暗环境
          <br />
          拍出明亮动人画面。
          <Link bordered={false} href="https://shop.vivo.com.cn/product/10006689" text="购买我的X60t Pro+" />
        </Description>
      </div>
      {mobile && (
        <div className="images-wrapper-m">
          <div>
            <Image paddingBottom="102.127%" src={IMAGES.m.i1} className="night-before" />
            <Description>其他手机拍摄</Description>
          </div>
          <div>
            <Image paddingBottom="102.127%" src={IMAGES.m.i2} className="night-after" />
            <Description>黑光夜视 2.0</Description>
          </div>
        </div>
      )}
      {!mobile && (
        <div className="images-wrapper">
          <div>
            <Image paddingBottom="102.127%" src={IMAGES.d.i1} className="night-before" />
            <Description>其他手机拍摄</Description>
          </div>
          <div>
            <Image paddingBottom="102.127%" src={IMAGES.d.i2} className="night-after" />
            <Description>黑光夜视 2.0</Description>
          </div>
        </div>
      )}
    </div>
  );
}
